import React from 'react';
import BuilderLayout from '../../components/builder/BuilderLayout';
import { DelegationsManagementPage } from '../shared/DelegationsManagementPage';

const BuilderPowersPage: React.FC = () => {
  return (
    <BuilderLayout>
      <DelegationsManagementPage mode="builder" />
    </BuilderLayout>
  );
};

export default BuilderPowersPage;
